/* icon-new.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1ejb%7Bheight%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1ejb%7Bwidth%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3ipxbi%7Bheight%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsbpxbi%7Bwidth%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3iutpp%7Bheight%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsbutpp%7Bwidth%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vc881r31%20stop%7Bstop-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._s7n4yfq0%7Bvertical-align%3Abottom%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._lcxvglyw%7Bpointer-events%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1r31%7Bcolor%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m915vq%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo15vq%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vwz4utpp%7Bline-height%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1kw7%7Bheight%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1kw7%7Bwidth%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20screen%20and%20(forced-colors%3Aactive)%7B._12va1onz%7Bcolor%3ACanvasText%7D._jcxd1r8n%7Bfilter%3Agrayscale(1)%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1mb9%7Bpadding-inline-start%3Avar(--ds--button--new-icon-padding-start%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4ti1igz%7Bpadding-inline-end%3Avar(--ds--button--new-icon-padding-end%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vwz4kb7n%7Bline-height%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zidpf%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchhusvi%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1o8l%7Bdisplay%3Ainline-block%7D");
import { memo } from 'react';
import type { UNSAFE_NewGlyphProps } from '../types';

/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */
export type InternalIconPropsNew = UNSAFE_NewGlyphProps & {
  /**
   * @internal NOT FOR PUBLIC USE.
   * Sets whether the icon should inherit size from a parent. Used by Icon Tile.
   */
  shouldScale?: boolean;
};
const svgStyles = null;
const iconStyles = null;
const smallIconStyles = null;
const scaleStyles = null;

/**
 * For windows high contrast mode
 */
const baseHcmStyles = null;
const scaleSize = null;
const coreSizeMedium = {
  none: "_1bsbpxbi _4t3ipxbi",
  compact: "_1bsb1ejb _4t3i1ejb",
  spacious: "_1bsb1ejb _4t3i1ejb"
};
const coreSizeSmall = {
  none: "_1bsbutpp _4t3iutpp",
  compact: "_1bsbpxbi _4t3ipxbi",
  spacious: "_1bsb1ejb _4t3i1ejb"
};
const paddingMap = ({
  medium: {
    none: 0,
    compact: 4,
    spacious: 4
  },
  small: {
    none: 0,
    compact: 2.66,
    spacious: 8
  }
} as const);

/**
 * __Icon__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 */
export const Icon: import("react").NamedExoticComponent<import("../types").UNSAFE_NewCoreGlyphProps> = memo(function Icon(props: UNSAFE_NewGlyphProps) {
  const {
    color = 'currentColor',
    testId,
    label,
    // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph,
    // Used with iconTile to scale icon up and down
    shouldScale,
    spacing = 'none',
    name
  } = (props as InternalIconPropsNew);
  const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
    __html: dangerouslySetGlyph
  } : undefined;
  let size: 'medium' | 'small' = 'medium';
  if ('size' in props && props.size !== undefined) {
    if (typeof props.size === 'string') {
      size = props.size === 'small' || props.size === 'medium' ? props.size : size;
    } else if (name) {
      const newSize = props.size(name);
      size = newSize === 'small' || newSize === 'medium' ? newSize : size;
    }
  }
  const baseSize = 16;
  const viewBoxPadding = paddingMap[size][spacing];
  const viewBoxSize = baseSize + 2 * viewBoxPadding;
  return <span data-testid={testId} role={label ? 'img' : undefined} aria-label={label ? label : undefined} aria-hidden={label ? undefined : true} style={{
    color
  }} className={ax(["_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9", "_12va1onz _jcxd1r8n", shouldScale && "_1bsb1kw7 _4t3i1kw7", size === 'small' && "_vwz4utpp"])}>
			<svg fill="none"
    // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
    // we want for Icon Tile
    viewBox={`${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`} role="presentation" dangerouslySetInnerHTML={dangerouslySetInnerHTML} className={ax(["_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31", shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? coreSizeSmall[spacing] : coreSizeMedium[spacing]])} />
		</span>;
});
export default Icon;